var React = require('react');
import { Link, browserHistory } from 'react-router';
var PropTypes = React.PropTypes;
var CollectionRes = require('../../resources/collection');
var ConceptRes = require('../../resources/concept');
var Auth = require("../../resources/auth");
var ReviewTaskRes = require('../../resources/review_task');
import CollectionsTable from './CollectionsTable';
import CircularProgress from 'material-ui/CircularProgress';
import '../../css/components/Collections/collections.css';
import { Pager } from 'react-bootstrap';
import createConfirm from '../Modal/createConfirm';
import notification from '../Modal/notification';

var Helpers = require("../../utils/helpers");

const TEACHER_STATUSES = [{
  title: 'Draft',
  code: 'draft',
  value: ['self'],
  actions: ['edit', 'delete'],
  count: '-',
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'dateCreated', 'dateModified', 'actions'],
  notes: [
    'All collections created by you will be listed below and only you can see them'
  ]
},{
  title: 'In Review',
  code: 'in-review',
  value: ['to_be_reviewed', 'reviewing'],
  actions: ['view'],
  count: '-',
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'round', 'dateCreated', 'dateSubmitted', 'dateModified', 'actions'],
  notes: [
    'Your collections already sent to be reviewed, when complete, you can see in "Need Revision" / "Completed" / "Rejected"'
  ]
},{
  title: 'Need Revision',
  code: 'need-revision',
  value: ['need_revisions', 'revising'],
  actions: ['revise', 'continue-revise'],
  count: '-',
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'round', 'dateCreated', 'dateSubmitted', 'dateModified', 'actions'],
  notes: [
    'Your collections reviewed by admin and admin requires revision before approving'
  ]
},{
  title: 'Completed',
  code: 'completed',
  value: ['complete', 'published'],
  actions: ['view'],
  count: '-',
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'round', 'dateCreated', 'dateSubmitted', 'dateModified', 'actions'],
  notes: [
    'Your collections have been reviewed and approved'
  ]
},{
  title: 'Rejected',
  code: 'rejected',
  value: ['rejected'],
  actions: ['view'],
  count: '-',
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'round', 'dateCreated', 'dateSubmitted', 'dateModified', 'actions'],
  notes: [
    'Your collections have been reviewed and rejected'
  ]
}];

const ADMIN_STATUSES = [{
  title: 'Draft',
  code: 'draft',
  value: ['self'],
  actions: ['edit', 'delete'],
  count: '-',
  canApplyAdminRole: false,
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'dateCreated', 'dateModified', 'actions'],
  notes: [
    'All collections created by you will be listed below and only you can see them'
  ]
},{
  title: "To be Reviewed",
  code: 'to-be-reviewed',
  value: ["to_be_reviewed"],
  actions: ["admin-review", "assign"],
  count: '-',
  canApplyAdminRole: true,
  include: 'review_task',
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'creator', 'round', 'dateSubmitted', 'dateModified', 'actions'],
  notes: [
    'All collections submitted by all setters and waiting for being assigned to reviewers',
    '"Review" action: Click to approve, reject or send back to setter for revision'
  ]
  
},{
  title: "In Review",
  code: 'in-review',
  value: ["reviewing"],
  actions: ["admin-review", "reassign"],
  count: '-',
  showReviewStat: true,
  // showReviewer: true,
  canApplyAdminRole: true,
  include: 'review_task',
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'creator', 'round', 'reviewer', 'finishReview', 'dateSubmitted', 'dateModified', 'actions'],
  notes: [
    'All collections already assigned to reviewers, and in review process',
    'For each collection, admin can wait for all assigned reviewers complete their jobs or admin can bypass to approve/send back to setter for revision/reject',
    '"Review" action: Click to approve, reject or send back to setter for revision',
    'Reviewers who finished or are doing their task are marked as green',
  ]
},{
  title: "To be Approved",
  code: "to-be-approved",
  value: ["to_be_approved"],
  actions: ["admin-review"],
  count: '-',
  showReviewStat: true,
  // showReviewer: true,
  canApplyAdminRole: true,
  include: 'review_task',
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'creator', 'round', 'reviewer', 'finishReview', 'dateSubmitted', 'dateModified', 'actions'],
  notes: [
    'All collections in this tabs are totally same to those in "In Review" but all assigned reviewers already complete their job in each collection',
    '"Review" action: Click to approve, reject or send back to setter for revision',
    'Reviewers who finished or are doing their task are marked as green'
  ]
},{
  title: 'Need Revision',
  code: 'need-revision',
  value: ['need_revisions'],
  actions: ["view"],
  count: '-',
  canApplyAdminRole: true,
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'creator', 'round', 'dateSubmitted', 'dateModified', 'actions'],
  notes: [
    'All collections which checked by admin but not approved because admin did set "Send back to setter for revision". After setters edit and submit to review again a collection, that collection will be displayed again in tab "To be Reviewed"'
  ]
},{
  title: "Completed",
  code: "completed",
  value: ["complete", "published"],
  actions: ["view", "admin-edit", "publish"],
  count: '-',
  canApplyAdminRole: true,
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'creator', 'round', 'dateSubmitted', 'dateModified', 'actions'],
  notes: [
    'All collections which approved by admin. This tab includes waiting-for-publishing and already-published collections',
    '"Publish" action: click to publish collection, make it available to students',
    '"Edit" action: click to modify questions in that collection'
  ]
},{
  title: "Rejected",
  code: 'rejected',
  value: ["rejected"],
  actions: ["view", "recover"],
  count: '-',
  canApplyAdminRole: true,
  cols: ['title', 'subject', 'concept', 'mcqStat', 'ssStat', 'lsStat', 'creator', 'round', 'dateSubmitted', 'dateModified', 'actions'],
  notes: [
    'Collections checked by admin but neither "need revision" or "approved", those collections are rejected forever',
    '"Recover" action: click to get back that collection and move to "In review" tab, after clicking on "Recover", go to "In review" to assign new reviewers to that collection'
  ]
}]

const includeConditions = {
  'review_task': {
    type: 'COLLECTION_REVIEW',
    status: {
      "$in": ['new', 'reviewing', 'done']
    }
  }
}

const ITEM_LIMIT = 20;

var CollectionsManagement = React.createClass({
  retrieveCollections: function(callback) {
    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    options.sort = this.state.sort || "-dateModified";
    options.conditions = {};
    options.conditions.status = {
      "$in": this.state.currentMode.value
    }
    if (!this.state.currentMode.canApplyAdminRole) {
      // options.conditions.creator = Auth.getCurrentUser()._id;
      //test
    }
    if (this.state.currentMode.include) {
      options.include = this.state.currentMode.include;
      options.includeConditions = includeConditions[options.include];
    }
    options.conditions.type = 'kquiz';

    //to pass in the current user's id to check (for school question bank)----------
    var currentUser = Auth.getCurrentUser();
    options.conditions2 = {};
    options.conditions2.userID = currentUser._id;
    options.conditions2.email = currentUser.email;
    //------------------------------------------------------------------------------

    CollectionRes.retrieveCollections(options, function(err, res) {

      //to filter off maths/science if current user is admin (i.e maths/science) so that only maths admin teacher can see maths question -------------------
      //and science teacher admin can only see science

      // Helpers.getSubject(_this.state.conceptsMap, data.concepts[0]).title
      var finalCollection = [];

      if (currentUser.adminType == "Maths" || currentUser.adminType == "Science") { //if admin teacher type

        var resLength = res.length;
        var conceptMap = _this.state.conceptsMap;
        for (var i = 0; i < resLength; i++) {
          
          var data = res[i];
          var subjectTitle = Helpers.getSubject(conceptMap, data.concepts[0]).title;

          if (subjectTitle == "Math" && currentUser.adminType == "Maths") { finalCollection.push(data); }
          else if (subjectTitle == "Science" && currentUser.adminType == "Science") { finalCollection.push(data); }
        }

      } else { //if not admin

        finalCollection = res;
      }

      //----------------------------------------------------------------------------------------------------------


      _this.setState({

        isLoading: false,
        collectionData: (!err && finalCollection) ? finalCollection: [{}]

      }, function() {
        _this.retrieveCollectionQuestionStat(function() {
          if (_this.state.currentMode.showReviewStat) {
            var collections = _this.state.collectionData;
            for (var i = 0; i < collections.length; i++) {
              _this.retrieveCollectionTaskStat(collections[i]);
            }
          }
        });
        return callback(err, res);
      });
    })
  },
  retrieveCollectionTaskStat: function(collection, callback) {
    callback = callback || function(){};
    var allCollections = this.state.collectionData,
        collectionIndex = allCollections.indexOf(collection),
        _this = this;
    collection.reviewStatMapping = {
      done: "-",
      currentDone: "-",
      total: "-",
      currentTotal: "-"
    }
    ReviewTaskRes.getAggregateCountField({
      groupFields: "status,type,reviewRound",
      conditions: JSON.stringify({
        type: "COLLECTION_REVIEW",
        content: collection._id
      })
    }, function(err, statCount) {
      if (!err && statCount) {
        collection.reviewStatMapping['total'] = 0;
        collection.reviewStatMapping['currentTotal'] = 0;
        collection.reviewStatMapping['done'] = 0;
        collection.reviewStatMapping['currentDone'] = 0;
        var currentReviewRound = collection.current_review_round || 1;
        for (var i = 0; i < statCount.length; i++) {
          if (statCount[i].status !== 'cancelled') {
            collection.reviewStatMapping['total'] += statCount[i].count;
            if (statCount[i].reviewRound === currentReviewRound)
              collection.reviewStatMapping['currentTotal'] += statCount[i].count;
          }
          if (statCount[i].status === 'done') {
            collection.reviewStatMapping['done'] += statCount[i].count;
            if (statCount[i].reviewRound === currentReviewRound)
              collection.reviewStatMapping['currentDone'] += statCount[i].count;
          }
        }
      }
      allCollections[collectionIndex] = collection;
      _this.setState({
        collectionData: allCollections
      }, () => {
        return callback();
      });
    })
  },
  retrieveCollectionQuestionStat: function(callback) {
    callback = callback || function(){};
    var collections = this.state.collectionData,
        collectionCount = collections.length,
        _this = this;
    for (var i in collections) {
      // collections[i].reviewStatMapping = {
      //   done: "-",
      //   total: "-"
      // };
      collections[i].questionStatMapping = {};
      CollectionRes.retrieveCollectionQuestionStat(collections[i], function(err, res) {
        collectionCount--;
        for (var j in res.questionStat) {
          res.questionStatMapping[res.questionStat[j].type] = res.questionStat[j];
        }
        if (collectionCount <= 0) {
          _this.forceUpdate(function() {
            return callback();
          });
        }
      })
    }
  },
  retrieveConceptsMap: function(callback) {
    callback = callback || function(){};
    var _this = this;
    ConceptRes.retrieveAllConceptsMap(function(err, conceptsMap) {
      _this.setState({

        conceptsMap: conceptsMap

      },()=>{

        //we change it to such that we will only get collections after the concepts are in (for checking)
        _this.retrieveCollections();

      })
      return callback(err, conceptsMap);
    })
  },
  countCollectionInMode: function(mode, callback) {
    var _this = this;
    callback = callback || function(){};
    mode.count = '-';
    
    var options = {};
    var conditions = {
      status: {
        '$in': mode.value
      },
      type: 'kquiz'
    }

    options.conditions = conditions;

    //to pass in the current user's id to check (for school question bank)----------
    var currentUser = Auth.getCurrentUser();
    options.conditions2 = {};
    options.conditions2.userID = currentUser._id;
    options.conditions2.email = currentUser.email;
    //------------------------------------------------------------------------------

    if (!mode.canApplyAdminRole) options.conditions.creator = Auth.getCurrentUser()._id;
    CollectionRes.countCollection(options, function(err, res) {
      if (!err && res) mode.count = res.count;
      else mode.count = 'No data';
      return callback();
    })
  },
  changeStatusMode: function(mode) {
    this.setState({
      currentMode: mode,
      collectionData: [],
      isLoading: true,
      currentPager: 1
    }, function() {
      this.retrieveCollections();
    });
  },

  deleteCollection: function(collection) {
    var _this = this;
    this.confirmable = createConfirm({
      title: 'CONFIRM',
      content: 'Are you sure you want to permanently delete this collection? It can not be undone'
    }, function() {
      _this.setState({
        openConfirm: false
      });
      CollectionRes.deleteCollection(collection, function(err, res) {
        if (err) {
          notification.open({
            message: "Error",
            description: "Cannot delete this description. Please try again later!"
          })
          return;
        }
        var collectionIndex = _this.state.collectionData.indexOf(collection);
        if (collectionIndex >= 0) {
          notification.open({
            message: "Success",
            description: "Collection has been deleted!"
          })
          _this.state.collectionData.splice(collectionIndex, 1);
          _this.setState({collectionData: _this.state.collectionData})
        }
      })
    }, function() {
      _this.setState({
        openConfirm: false
      });
    })
    this.setState({
      openConfirm: true
    })
  },

  navigatePager: function(dir) {
    var currentPager = this.state.currentPager,
        _this = this;
    currentPager += dir;
    _this.setState({
      currentPager: currentPager,
      isLoading: true
    }, function() {
      this.retrieveCollections(function(err, res) {
      })
    })
  },

  updateSingleCollection: function(collection, callback) {
    callback = callback || function(){};
    var options = {
      conditions: {
        _id: collection._id
      }
    };
    if (this.state.currentMode.include) {
      options.include = this.state.currentMode.include;
      options.includeConditions = includeConditions[options.include]
    }
    CollectionRes.retrieveCollections(options, (err, newCollections) => {
      if (err) return callback(err);
      Object.assign(collection, newCollections[0])
      if (this.state.currentMode.showReviewStat) {
        this.retrieveCollectionTaskStat(collection, function() {
          return callback(null, collection);
        });
      } else {
        return callback(null, collection);
      }
    })
  },

  onSortChange: function(newSort) {
    this.setState({
      sort: newSort,
      collectionData: [],
      isLoading: true,
      currentPager: 1,
    }, () => {
      this.retrieveCollections();
    });
  },

  getInitialState: function() {
    return {
      statusMode: [],
      currentMode: {},
      collectionData: [],
      isLoading: true,
      conceptsMap: null,
      currentPager: 1,
      sort: '-dateModified'
    };
  },

  componentWillReceiveProps: function(nextProps) {

  },

  componentWillMount: function() {

  },

  render: function() {
    var _this = this;

    var currentUser = Auth.getCurrentUser(),
        isAdmin = currentUser && currentUser.status && currentUser.status.indexOf('admin') >= 0;

    return (
      <div className="collections">
        {this.state.openConfirm && this.confirmable}
        <div className="content-toolbar">
          <h3>Collection Management</h3>
          <div className="btn-holder">
            {/*{
              isAdmin && 
              <Link to={"collection/new"}>
                <button className="btn btn-success">
                  <i className="fa fa-plus" style={{"paddingRight": "5px"}}></i>
                  <span>New Collection</span>
                </button>
              </Link>
            }*/}
            <Link to={"collection/new"}>
                <button className="btn btn-success">
                  <i className="fa fa-plus" style={{"paddingRight": "5px"}}></i>
                  <span>New Collection</span>
                </button>
              </Link>
          </div>
        </div>
        <div style={{"border": "1px solid #ddd", "padding": "10px"}}>
          <div className="collection-statuses">
            <div className="dp-table" style={{"tableLayout": "fixed", "width": "100%"}}>
              {
                this.state.statusMode.map(function(mode, index) {
                  return (
                    <div key={index} className={"dp-table-cell cell " + (_this.state.currentMode === mode ? 'active' : '')} onClick={_this.changeStatusMode.bind(_this, mode)}>{mode.title + ' (' + mode.count + ')'}</div>
                  )
                })
              }
            </div>
          </div>
          <hr/>
          {
            (_this.state.collectionData.length > 0 && !_this.state.isLoading) &&
            <CollectionsTable
              data={this.state.collectionData}
              conceptsMap={this.state.conceptsMap}
              mode={this.state.currentMode}
              sort={this.state.sort}
              onDelete={this.deleteCollection}
              onSortChange={this.onSortChange}
              onUpdateSingleCollection={this.updateSingleCollection}
            />
          }
          {
            _this.state.isLoading &&
            <CircularProgress />
          }
          <Pager>
            {
              _this.state.currentPager > 1 &&
              <Pager.Item
                onClick={_this.navigatePager.bind(_this, -1)}
                disabled={_this.state.currentPager === 1}
              >
                Previous
              </Pager.Item>
            }
            {' '}
            {
              _this.state.collectionData.length >= ITEM_LIMIT &&
              <Pager.Item
                onClick={_this.navigatePager.bind(_this, 1)}
                disabled={_this.state.collectionData.length < ITEM_LIMIT}
              >
                Next
              </Pager.Item>
            }
          </Pager>
        </div>
      </div>
    );
  },

  componentDidMount: function() {
    var _this = this;
    var statusMode = this.state.statusMode;
    var currentUser = Auth.getCurrentUser();
    if (currentUser.status.indexOf('reviewer') >= 0) return browserHistory.push('/review-tasks');
    if (currentUser.role === 'admin') {
      statusMode = ADMIN_STATUSES;
    } else  {
      statusMode = TEACHER_STATUSES;
    }
    var currentMode = statusMode[0];
    if (this.props.location.query.mode) {
      var mode = this.props.location.query.mode,
          mappedMode = statusMode.filter((value) => {
            return value.code === mode
          })[0];
      if (mappedMode) currentMode = mappedMode;
    }
    this.setState({
      isLoading: true,
      statusMode: statusMode,
      currentMode: currentMode
    }, function() {
      var count = statusMode.length;
      for (var i = 0; i < statusMode.length; i++) {
        this.countCollectionInMode(statusMode[i], function() {
          count--;
          if (count <= 0) _this.forceUpdate();
        });
      }
      // this.retrieveCollections();
      this.retrieveConceptsMap();
    });
  },

});

export default CollectionsManagement;



/** WEBPACK FOOTER **
 ** ./src/components/Collections/CollectionsManagement.js
 **/